import React from 'react';
const ButtonLoader = ({
    buttonText,
    onClick,
    isLoading,
    loaderButtonText = undefined,
    disabled,
    className,
    type = undefined,
    divClassName = '',
}) => {
    // The spinner stays mounted and is only hidden: inserting it next to the button's
    // text node crashes React once browser page translation has replaced that node.
    const renderLoader = () => {
        return (
            <div
                className={'loader-inner ball-clip-rotate'}
                style={{ display: isLoading ? 'contents' : 'none' }}>
                <div
                    style={{
                        border: '3px dotted  #ffffff ',
                        height: '11px',
                        width: '11px',
                        marginRight: '10px',
                    }}></div>
            </div>
        );
    };

    const buttonContent = () =>
        isLoading && loaderButtonText ? loaderButtonText : buttonText;

    return (
        <div className={'ButtonLoader-Div ' + divClassName}>
            {type ? (
                <button
                    type={type}
                    className={className}
                    onClick={() => onClick()}
                    disabled={disabled || isLoading}>
                    {renderLoader()}
                    {buttonContent()}
                </button>
            ) : (
                <button
                    className={className}
                    onClick={() => onClick()}
                    disabled={disabled || isLoading}>
                    {renderLoader()}
                    {buttonContent()}
                </button>
            )}
        </div>
    );
};
export default ButtonLoader;
